import React from "react";

import S from "./Text.styled";

export interface Props {
  text: string;
}

const Text: React.FC<Props> = ({ text }) => {
  return (
    <S.TextContainer>
      <div className="md:mx-auto md:max-w-3xl py-12 pb-24">
        <div dangerouslySetInnerHTML={{ __html: text ?? "" }}></div>
      </div>
    </S.TextContainer>
  );
};

export default Text;
